import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConsultaInformeEncuestasI } from 'src/app/infraestructure/models/consultaInformeEncuestas';

@Component({
  selector: 'app-table-satisfaction-survey',
  templateUrl: './table-satisfaction-survey.component.html',
  styleUrls: ['./table-satisfaction-survey.component.scss']
})
export class TableSatisfactionSurveyComponent implements OnInit {

  @Input() dataTable: ConsultaInformeEncuestasI[] = [];
  @Output() export = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  onExport() {
    this.export.emit(true);
  }
}
